import { useEffect, useState } from "react";
import { ArrowRight, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LoginButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 2500);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div
			className={`duration-800 mt-12 transition-all ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}
		>
			<div className="relative">
				{/* Linha de contorno neon passando pela borda */}
				<div className="absolute -inset-1 overflow-hidden rounded-2xl">
					<div
						className="absolute inset-0 animate-[border-flow_2s_linear_infinite] rounded-2xl"
						style={{
							background:
								"conic-gradient(from 0deg, transparent 270deg, hsl(142 76% 50%) 290deg, hsl(142 86% 45%) 310deg, transparent 330deg)",
						}}
					></div>
				</div>

				<Button
					size="lg"
					className="bg-gradient-success hover:shadow-glow text-success-foreground group relative z-10 overflow-hidden rounded-2xl border-0 px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
				>
					{/* Shimmer effect */}
					<div className="absolute inset-0 translate-x-[-100%] bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-opacity transition-transform duration-1000 duration-500 group-hover:translate-x-[100%] group-hover:opacity-100"></div>

					<div className="relative flex items-center gap-3">
						<LogIn className="h-6 w-6 transition-transform duration-300 group-hover:rotate-12" />
						<span>Ir para o Login</span>
						<ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
					</div>
				</Button>
			</div>
		</div>
	);
};
